export function isSameAirlineSwitchedOff(filtersStatus: Pick<TransportFiltersResponse, 'sameAirline'>): boolean {
  return filtersStatus.sameAirline?.on === false;
}
